import React, { useEffect, useState } from 'react';

import { TableBody, TableCell, TableRow } from '@material-ui/core';

import { TIFormatPrefix } from '../../../../../../../../store/admin/roundFormats/store';
import { IResult } from '../../../../../../../../store/admin/roundResults/store';

import { groupBy } from '../../../../../../../../contrib/utils';
import {
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../../../../Common/AssignResults/Context/AssignResults.context';
import { getResultFieldName } from '../../../../../Common/ResultsTable/Utils/getResultFieldName';
import { HorseRaceTableRow } from './HorseRaceTableRow';

export interface IResultsByHole {
  [index: string]: IResult[];
}

export const HorseRaceTableBody = () => {
  const {
    selectedCombination,
    results,
    roundFormatsList,
    sortedResults,
    horseRaceEliminatedResults
  } = useAssignResultsState();

  const [scoreFieldName, setScoreFieldName] = useState<keyof IResult | undefined>();

  const [resultsByHole, setResultsByHole] = useState<{}>({});

  const {
    actions: { setHorseRaceEliminatedResults }
  } = useAssignResultsDispatch();

  useEffect(() => {
    if (selectedCombination && selectedCombination.scoreType) {
      setHorseRaceEliminatedResults(selectedCombination.format, selectedCombination.scoreType);
    }
  }, [selectedCombination, sortedResults]);

  useEffect(() => {
    if (selectedCombination) {
      const {
        format: {
          considerFlights,
          format: { prefix }
        },
        scoreType
      } = selectedCombination;

      const processedPrefix = `${prefix}${considerFlights ? 'Flight' : 'Round'}` as TIFormatPrefix;

      const positionFieldName = getResultFieldName(processedPrefix, scoreType, 'Hole');

      setScoreFieldName(getResultFieldName(processedPrefix, scoreType, 'Score'));

      if (horseRaceEliminatedResults.true) {
        setResultsByHole(groupBy(horseRaceEliminatedResults.true, positionFieldName));
      }
    }
  }, [results, roundFormatsList, horseRaceEliminatedResults, sortedResults, selectedCombination]);

  return (
    <TableBody className="results-table-table-body">
      {resultsByHole && Object.keys(resultsByHole).length > 0 ? (
        Object.keys(resultsByHole)
          .reverse()
          .map((hole: string, index: number) => (
            <HorseRaceTableRow
              hole={hole}
              index={index}
              key={index}
              scoreFieldName={scoreFieldName}
              resultsByHole={resultsByHole}
            />
          ))
      ) : (
        <TableRow>
          <TableCell colSpan={4} className="no-results">
            No results to show
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};
